import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { marked } from "marked";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPage(null); setError(null);
    api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setError("Page not found"));
  }, [slug]);

  if (error) return (
    <main className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="page-not-found">
      <h1 className="font-serif text-3xl">Page not found</h1>
      <Link to="/" className="btn-ghost mt-6 inline-flex">Back to home</Link>
    </main>
  );
  if (!page) return <main className="py-32 text-center text-neutral-500">Loading…</main>;

  const html = marked.parse(page.body || "");

  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-14 md:py-20" data-testid="custom-page">
      <Seo title={page.seo_title || page.title}
           description={page.seo_description || page.excerpt} />
      <p className="eyebrow text-neutral-500">Aura & Co.</p>
      <h1 className="font-serif text-4xl md:text-6xl mt-3 mb-12 leading-tight" data-testid="page-title">{page.title}</h1>
      <article
        className="prose-aura font-light text-base md:text-lg leading-relaxed text-neutral-800"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </main>
  );
}
